import { useState } from 'react';
import { ChevronDownIcon } from '@rsos/assets/icons';
import { Box } from '@rsos/components/capstone/base';
import {
  CaretWrapper,
  CustomAccordionContent,
  CustomAccordionHeader,
  CustomAccordionWrapper,
} from './GISLayerControls.styles';

// A checkbox for solo layers; an accordion for layers with sublayers.
export const GISLayerAccordion: React.FunctionComponent<{
  title: JSX.Element;
  body: JSX.Element;
  headerAction?: JSX.Element | null;
}> = ({ title, body, headerAction }) => {
  const [isAccordionExpanded, setIsAccordionExpanded] = useState(false);

  return (
    <CustomAccordionWrapper>
      <CustomAccordionHeader
        isExpanded={isAccordionExpanded}
        onClick={() => setIsAccordionExpanded(o => !o)}
      >
        <Box onClick={e => e.stopPropagation()}>{title}</Box>
        <Box horizontal align="center">
          {headerAction && (
            <Box onClick={e => e.stopPropagation()}>{headerAction}</Box>
          )}
          <CaretWrapper isExpanded={isAccordionExpanded}>
            <ChevronDownIcon color="secondaryText" width={10} height={10} />
          </CaretWrapper>
        </Box>
      </CustomAccordionHeader>
      {isAccordionExpanded && (
        <CustomAccordionContent>{body}</CustomAccordionContent>
      )}
    </CustomAccordionWrapper>
  );
};
